// extracted by mini-css-extract-plugin
export default {"boardsCard":"CreateBoard_boardsCard__XKQRB","boardsButton":"CreateBoard_boardsButton__QD8e8"};